import { render } from "./registroUser.vue?vue&type=template&id=2ada4a42&ts=true"
import script from "./registroUser.vue?vue&type=script&lang=ts"
export * from "./registroUser.vue?vue&type=script&lang=ts"

import "./registroUser.vue?vue&type=style&index=0&id=2ada4a42&lang=scss"

import exportComponent from "F:\\200 Desarrollos\\SIE\\SIE-Publico\\SIE.Frontend\\WEB.Home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__